define(['plugins/router'], router => {
    const { isAdmin } = settings;

    let fakeRouter = {
        navigate: _.noop,
        activeInstruction: ko.observable(null)
    };

    if (isAdmin)
        return fakeRouter;

    return router;
});